import React, { useRef, useEffect, useState } from "react";

//---propiedades borde=true, cade='00001'
//si la propiedad es "00000" , no se dibuja el circulo 
const CirculoCaries2 = (props) => {
  //console.log("props.value:"+ props.value);
  let soloLectura = props.soloLectura || false;

  const [cade_temp, setCadeTemp] = useState(props.value); 

  //----------------cada que cambie el valor de piezas=props.value
  //-------------actualizamos
  useEffect(() => {
    setCadeTemp(props.value)
  }, [props.value]);
  //---------------------------------------------------------------
  //--------valores iniciales  fill="#d1d9de"
  let pieza = props.pieza;

  let color0= '#e8ecef';
  let color1= '#e8ecef';
  let color2= '#e8ecef';
  let color3= '#e8ecef';
  let color4= '#e8ecef'; 
  //"#d1d9de"
  //console.log('cade_temp:'+ cade_temp);
  //---si es '0', ocultamos la muestra 
  if(cade_temp==='00000' || cade_temp==='' ){
    //elemSvg.getElementById( piezax +"_0").setAttribute("style", "fill:silver");
    if(props.borde==="true"){
      //continuamos
    }else{
      return;
    }
  }
  //de lo contrario calculamos quienes estan pintados
  const myArray = cade_temp.split("");

  //--ahora cada elemento, lo recorremos 
  for (let i = 0; i < myArray.length ; i++) {
    let valor = myArray[i];   
    //console.log(valor+"-");
    //ahora si lo cambiamos de color
    if(i===0){ //top
      if(valor==='1'){  color0 = 'red'; }
    }
    if(i===1){ //botton
      if(valor==='1'){  color1 = 'red'; }
    }
    if(i===2){ //izq
      if(valor==='1'){  color2 = 'red'; }
    }
    if(i===3){ //der
      if(valor==='1'){  color3 = 'red'; }
    }
    if(i===4){ //centro
      if(valor==='1'){  color4 = 'red'; }
    }
  }
  
  //-------------agregamos el item con su informacion para propositos futuros
  const onClick0 = (e) => {
    // 👇️ filter with 1 condition
    //console.log(e.target.value);
    if(soloLectura===true) {return;}

    let myArray = cade_temp.split(""); //convertimos en array
    //console.log("->"+myArray[0]);
    if(myArray[0]==='0'){
      myArray[0]='1';
    }else{
      myArray[0]='0';
    }
    //console.log(myArray.join(''));
    let new_cade= myArray.join('');
    setCadeTemp(new_cade);
    //--lo convertimos a cadena

    //props.onChange(e);
  }
  //-------------------------------------
  const onClick1 = (e) => {
    if(soloLectura===true) {return;}

    let myArray = cade_temp.split(""); //convertimos en array
    //console.log("->"+myArray[0]);
    if(myArray[1]==='0'){
      myArray[1]='1';
    }else{
      myArray[1]='0';
    }
    let new_cade= myArray.join('');
    setCadeTemp(new_cade);
    
    //props.onChange(e);
  }
  //-------------------------------------
  const onClick2 = (e) => {
    if(soloLectura===true) {return;}

    let myArray = cade_temp.split(""); //convertimos en array
    //console.log("->"+myArray[0]);
    if(myArray[2]==='0'){
      myArray[2]='1';
    }else{
      myArray[2]='0';
    }
    let new_cade= myArray.join('');
    setCadeTemp(new_cade);
    
    //props.onChange(e);
  }
  //-------------------------------------
  const onClick3 = (e) => {
    if(soloLectura===true) {return;}

    let myArray = cade_temp.split(""); //convertimos en array
    //console.log("->"+myArray[0]);
    if(myArray[3]==='0'){
      myArray[3]='1';
    }else{
      myArray[3]='0';
    }
    let new_cade= myArray.join('');
    setCadeTemp(new_cade);
    
    //props.onChange(e);
  }
  //-------------------------------------
  const onClick4 = (e) => {
    if(soloLectura===true) {return;}

    let myArray = cade_temp.split(""); //convertimos en array
    //console.log("->"+myArray[0]);
    if(myArray[4]==='0'){
      myArray[4]='1';
    }else{
      myArray[4]='0';
    }
    let new_cade= myArray.join('');
    setCadeTemp(new_cade);
    
    //props.onChange(e);
  }
  return(
    <>
    
      <svg 
         viewBox="0 0 6 6"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
      >
     
      <path
        id="m0_0"
        fill={color0}
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeWidth="0.053"
        d="M 2.9876599,0.70375796 C 1.7363583,0.73863978 0.94501669,1.5709837 0.94501669,1.5709837 L 1.8492979,2.4722971 c 0.5467858,-0.6178223 1.5958497,-0.7503018 2.3139462,0.0058 l 0.915751,-0.912744 C 4.9903201,1.4787244 4.2646705,0.73702251 2.9876599,0.70375796 Z"
        display="inline"
        onClick={onClick0}
        
      ></path>
      <path
        id="m0_3"
        fill={color3}
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeWidth="0.053"
        d="M 4.209734,2.5337793 5.1213336,1.6200092 c 0,0 0.8172232,0.666674 0.8468893,2.0686465 C 5.9221695,5.0183521 5.1263578,5.7328812 5.1263578,5.7328812 L 4.0611483,4.6773274 C 4.923468,3.8175536 4.5155289,2.8905403 4.209734,2.5337793 Z"
        display="inline"
        onClick={onClick3}
      ></path>
      
      <circle
        id="m0_4"
        fill={color4}
        stroke="#000"
        strokeWidth="0.064"
        cx={3.0023482}
        cy={3.5321729}
        r={1.4747984}
        
        onClick={onClick4}
      />
      <path
        id="m0_1"
        fill={color1}
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeWidth="0.053"
        d="m 4.0102435,4.7306785 1.0578681,1.0561747 c 0,0 -0.7414798,0.7842372 -2.0468395,0.8321607 C 1.8130384,6.6314457 0.95726819,5.7903993 0.95726819,5.7903993 L 2.0003554,4.7401214 c 0.4460126,0.409109 1.3931599,0.5731084 2.0098881,-0.00944 z"
        display="inline"
        onClick={onClick1}
      ></path>
   
    <path
      id="m0_2"
      fill={color2}
      fillRule="evenodd"
      stroke="#000"
      strokeDasharray="none"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit="4"
      strokeOpacity="1"
      strokeWidth="0.053"
      d="M 1.9468133,4.6967058 0.91205968,5.732264 c 0,0 -0.82506725,-0.8009427 -0.84796701,-2.0567053 C 0.05795828,2.412894 0.89688088,1.6122768 0.89688088,1.6122768 L 1.8038292,2.5224214 C 1.1371807,3.3636023 1.4606769,4.2889789 1.9468133,4.6967058 Z"
      display="inline"
      onClick={onClick2}
    ></path>
  </svg>
    </>
 
  )
}
export default CirculoCaries2;